import { render } from "./PartColor.vue?vue&type=template&id=15e4a9b8&scoped=true&ts=true&lang=pug"
import script from "./PartColor.vue?vue&type=script&lang=ts"
export * from "./PartColor.vue?vue&type=script&lang=ts"

import "./PartColor.vue?vue&type=style&index=0&id=15e4a9b8&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15e4a9b8"]])

export default __exports__